( function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .controller( "LotFormModalController", LotFormModalController );

    LotFormModalController.$inject = [ '$uibModalInstance', 'Lot', 'ToastrService', 'siEntity',
                        'contractEntity', 'contractBEntity', 'contractCEntity', 'contractDEntity', 'contractEEntity', 'contractFEntity', 'saleContractEntity'];

    function LotFormModalController( $uibModalInstance, Lot, ToastrService, siEntity,
                                     contractEntity, contractBEntity, contractCEntity, contractDEntity, contractEEntity, contractFEntity, saleContractEntity) {
        var vm = this;

        //build empty Lot
        vm.lot = {
            createdOn: new Date(),
            createdBy: 'user',
            modifiedOn: new Date(),
            modifiedBy: 'user',
            lotRef: "LOT." + new Date().getTime(),
            farmRef: null,
            ginRef: null,
            lotStatus: "ALLOCATED",
            loadingDate: null,
            loadingPeriod: null,
            loadingPlace: null,
            loadingWarehouse: null,
            destPlace: null,
            destWarehouse: null,
            qtyBales: 1,
            qtyUnitType: null,
            cropYear: null,
            //purchase default values
            purchase: null,
            purchPriceUnit: null,
            purchPrice: 0,
            purchWtType: null,
            purchGrossKgs: 0,
            purchNetKgs: 0,
            purchTareKgs: 0,
            purchGrossLbs: 0,
            purchNetLbs: 0,
            purchTareLbs: 0,
            purchGrossMTs: 0,
            purchNetMTs: 0,
            purchTareMTs: 0,
            purchLandedGrossKgs: 0,
            purchLandedNetKgs: 0,
            purchLandedTareKgs: 0,
            purchLandedGrossLbs: 0,
            purchLandedNetLbs: 0,
            purchLandedTareLbs: 0,
            purchLandedGrossMTs: 0,
            purchLandedNetMTs: 0,
            purchLandedTareMTs: 0,
            purchValue: 0,
            //inter default values
            interPriceUnit: null,
            interPrice: 0,
            interWtType: null,
            interGrossKgs: 0,
            interNetKgs: 0,
            interTareKgs: 0,
            interGrossLbs: 0,
            interNetLbs: 0,
            interTareLbs: 0,
            interGrossMTs: 0,
            interNetMTs: 0,
            interTareMTs: 0,
            interLandedGrossKgs: 0,
            interLandedNetKgs: 0,
            interLandedTareKgs: 0,
            interLandedGrossLbs: 0,
            interLandedNetLbs: 0,
            interLandedTareLbs: 0,
            interLandedGrossMTs: 0,
            interLandedNetMTs: 0,
            interLandedTareMTs: 0,
            interValue: 0,
            //sale default values
            allocSale: null,
            allocSi: null,
            salePriceUnit: null,
            salePrice: 0,
            saleFinalPrice: 0,
            saleWtType: null,
            saleGrossKgs: 0,
            saleNetKgs: 0,
            saleTareKgs: 0,
            saleGrossLbs: 0,
            saleNetLbs: 0,
            saleTareLbs: 0,
            saleGrossMTs: 0,
            saleNetMTs: 0,
            saleTareMTs: 0,
            saleLandedGrossKgs: 0,
            saleLandedNetKgs: 0,
            saleLandedTareKgs: 0,
            saleLandedGrossLbs: 0,
            saleLandedNetLbs: 0,
            saleLandedTareLbs: 0,
            saleLandedGrossMTs: 0,
            saleLandedNetMTs: 0,
            saleLandedTareMTs: 0,
            //default pricing
            saleValue: 0,
            landedValue: 0,
            invoiceValue: 0,
            //default weight avgs
            actualWtAvg: 0,
            landedWtAvg: 0,
            actualWtGrossAvg: 0,
            landedWtGrossAvg: 0,
            actualWtTareAvg: 0,
            landedWtTareAvg: 0,
            //default quality
            lotType: null,
            lotMic: null,
            lotLen: null,
            lotStr: null,
            lotRdb: null,
            lotSfi: null,
            //default misc
            origin: null,
            producer: null,
            placeOfTakeUp: null,
            takeUpNr: null,
            imported: false,
            growth: null,
            seller: null,
            id: null
        };

        vm.datePickerOpenStatus = {};

        if( siEntity.id !== null ) {
            vm.lot.purchSi = siEntity;
            if( saleContractEntity ) {
                vm.lot.allocSi = siEntity;
            }
        }

        //controller defaults
        vm.showPContractDetails = false;
        //actual weights holder
        vm.actualWeightNet = 0;
        vm.actualWeightGross = 0;
        vm.actualWeightTare = 0;
        vm.actualWeightAvg = 0;
        vm.actualWeightGrossAvg = 0;
        vm.actualWeightTareAvg = 0;
        //landed weights holder
        vm.landedWeightNet = 0;
        vm.landedWeightGross = 0;
        vm.landedWeightTare = 0;
        vm.landedWeightAvg = 0;
        vm.landedWeightGrossAvg = 0;
        vm.landedWeightTareAvg = 0;

        vm.pContractList = [];
        fetchContracts();

        function fetchContracts() {
            vm.pContractList.length = 0;
            if( contractEntity ) {
                vm.pContractList.push( contractEntity );
            }
            if( contractBEntity ) {
                vm.pContractList.push( contractBEntity );
            }
            if( contractCEntity ) {
                vm.pContractList.push( contractCEntity );
            }
            if(contractDEntity) {
                vm.pContractList.push(contractDEntity);
            }
            if(contractEEntity) {
                vm.pContractList.push(contractEEntity);
            }
            if(contractFEntity) {
                vm.pContractList.push(contractFEntity);
            }
            if( saleContractEntity ) {
                vm.lot.allocSale = saleContractEntity;
            }
            if( vm.pContractList.length === 1) {
                vm.lot.purchase = vm.pContractList[0];
                applyPurchaseContractStuff();
            }
        }

        //lists
        vm.lotStatuses = ['ALLOCATED'];
        vm.wtTypes = ['KG','LB','MT'];
        //set default weight type
        vm.lot.purchWtType = vm.wtTypes[0];

        vm.submit = submit;
        vm.cancel = cancel;
        vm.openCalendar = openCalendar;

        function submit() {
            if( vm.lot.purchWtType === "" || vm.lot.purchWtType === null ) {
                ToastrService.error( "Lot Details Tab: No Qty Unit Type chosen", "Error" );
            } else if( vm.lot.purchase === "" || vm.lot.purchase === null ) {
                ToastrService.error( "Purchase Contract Tab: No Purchase Contract Selected", "Error" );
            } else {
                if( siEntity.id !== null ) {
                    Lot.save( vm.lot, function( result ) {
                        ToastrService.success( "Created Lot Success!", "Success!" );
                        vm.lot.id = result.id;
                        $uibModalInstance.close( vm.lot );
                    }, function( error ) {
                        ToastrService.error( "Something went wrong when saving Lot", "Error!" );
                        console.log( error.message );
                    });
                } else {
                    ToastrService.info( "Added Lot to New Shipment", "Info" );
                    vm.lotStatus = "AVAILABLE";
                    $uibModalInstance.close( vm.lot );
                }
            }
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        //fancy way to select all text inside input box on click
        vm.onTextClick = function( $event ) {
            $event.target.select();
        };

        //==========================================
        //Purchase & Allocation tab
        //==========================================
        vm.applyPurchaseContractStuff = applyPurchaseContractStuff;

        function applyPurchaseContractStuff() {
            if( vm.lot.purchase !== null && vm.lot.purchase !== undefined ) {
                vm.showPContractDetails = true;
                vm.lot.cropYear = vm.lot.purchase.cropYear;
                if( vm.lot.purchase.seller !== null && vm.lot.purchase.seller !== undefined ) {
                    vm.lot.seller = vm.lot.purchase.seller.name;
                }
                if( vm.lot.purchase.growth !== null && vm.lot.purchase.growth !== undefined ) {
                    vm.lot.growth = vm.lot.purchase.growth.location;
                }
            } else {
                vm.showPContractDetails = false;
                vm.lot.cropYear = null;
                vm.lot.seller = null;
                vm.lot.growth = null;
            }
        }

        //==========================================
        //Lot Details tab
        //==========================================
        //set date picker open statuses
        vm.datePickerOpenStatus.loadingDate = false;

        vm.activateLotStatus = activateLotStatus;
        vm.activateWtType = activateWtType;
        vm.calculateAvgNet = calculateAvgNet;

        //open selected calendar
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        //setting lot status with selected lot status button
        function activateLotStatus( option ) {
            vm.lot.lotStatus = option;
        }

        //setting selected weight type for lot
        function activateWtType( option ) {
            vm.lot.purchWtType = option;
            assignWeights();
        }

        //calculate avg waight based on qty bales and net & landed net weight
        function calculateAvgNet() {
            if( isNaN( vm.lot.qtyBales ) || vm.lot.qtyBales === null || vm.lot.qtyBales === '' || vm.lot.qtyBales === undefined ) {
                vm.lot.qtyBales = 1;
            }
            //set actual avgs
            var actualTare = vm.actualWeightGross - vm.actualWeightNet;
            vm.actualWeightAvg = Math.round(( vm.actualWeightNet / vm.lot.qtyBales ) * 100 ) / 100;
            vm.actualWeightGrossAvg = Math.round( ( vm.actualWeightGross / vm.lot.qtyBales ) * 100 ) / 100;
            vm.actualWeightTareAvg = Math.round( ( actualTare / vm.lot.qtyBales ) * 100 ) / 100;
            vm.lot.actualWtAvg = vm.actualWeightAvg;
            vm.lot.actualWtGrossAvg = vm.actualWeightGrossAvg;
            vm.lot.actualWtTareAvg = vm.actualWeightTareAvg;
            //set landed avgs
            var landedTare = vm.landedWeightGross - vm.landedWeightNet;
            vm.landedWeightAvg = Math.round(( vm.landedWeightNet / vm.lot.qtyBales ) * 100 ) / 100;
            vm.landedWeightGrossAvg = Math.round( ( vm.landedWeightGross / vm.lot.qtyBales ) * 100 ) / 100;
            vm.landedWeightTareAvg = Math.round( ( landedTare / vm.lot.qtyBales ) * 100 ) / 100;
            vm.lot.landedWtAvg = vm.landedWeightAvg;
            vm.lot.landedWtGrossAvg = vm.landedWeightGrossAvg;
            vm.lot.landedWtTareAvg = vm.landedWeightTareAvg;
            if( vm.lot.purchWtType !== "" || vm.lot.purchWtType !== null || vm.lot.purchWtType !== undefined ) {
                assignWeights();
            }
        }

        //assign weights to chosen wt type
        function assignWeights() {
            var actualNet = vm.actualWeightNet;
            var actualGross = vm.actualWeightGross;
            var actualTare = Math.round( ( actualGross - actualNet ) * 100 ) / 100;
            vm.actualWeightTare = actualTare;
            var landedNet = vm.landedWeightNet;
            var landedGross = vm.landedWeightGross;
            var landedTare = Math.round( ( landedGross - landedNet ) * 100 ) / 100;
            vm.landedWeightTare = landedTare;
            switch( vm.lot.purchWtType ) {
                case 'KG':
                    //actual
                    vm.lot.purchNetKgs = actualNet;
                    vm.lot.purchGrossKgs = actualGross;
                    vm.lot.purchTareKgs = actualTare;
                    //landed
                    vm.lot.purchLandedNetKgs = landedNet;
                    vm.lot.purchLandedGrossKgs = landedGross;
                    vm.lot.purchLandedTareKgs = landedTare;
                    //lot weight kgs
                    vm.lot.lotWeightKgs = landedNet;
                    resetWeights('LB');
                    resetWeights('MT');
                    break;
                case 'LB':
                    //actual
                    vm.lot.purchNetLbs = actualNet;
                    vm.lot.purchGrossLbs = actualGross;
                    vm.lot.purchTareLbs = actualTare;
                    //landed
                    vm.lot.purchLandedNetLbs = landedNet;
                    vm.lot.purchLandedGrossLbs = landedGross;
                    vm.lot.purchLandedTareLbs = landedTare;
                    //lot weight lbs
                    vm.lot.lotWeightLbs = landedNet;
                    resetWeights('KG');
                    resetWeights('MT');
                    break;
                case 'MT':
                    //actual
                    vm.lot.purchNetMTs = actualNet;
                    vm.lot.purchGrossMTs = actualGross;
                    vm.lot.purchTareMTs = actualTare;
                    //landed
                    vm.lot.purchLandedNetMTs = landedNet;
                    vm.lot.purchLandedGrossMTs = landedGross;
                    vm.lot.purchLandedTareMTs = landedTare;
                    //lot weight mts
                    vm.lot.lotWeightMts = landedNet;
                    resetWeights('LB');
                    resetWeights('KG');
                    break;
            }
            vm.lot.lotWeightDisplay = landedNet + " " + vm.lot.purchWtType;
        }

        //reset weights to wts types not chosen. This will be handled at the backend
        function resetWeights( wtType ) {
            switch( wtType ) {
                case 'KG':
                    //actual
                    vm.lot.purchNetKgs = 0;
                    vm.lot.purchGrossKgs = 0;
                    vm.lot.purchTareKgs = 0;
                    //landed
                    vm.lot.purchLandedNetKgs = 0;
                    vm.lot.purchLandedGrossKgs = 0;
                    vm.lot.purchLandedTareKgs = 0;
                    //lot weight
                    vm.lot.lotWeightKgs = 0;
                    break;
                case 'LB':
                    //actual
                    vm.lot.purchNetLbs = 0;
                    vm.lot.purchGrossLbs = 0;
                    vm.lot.purchTareLbs = 0;
                    //landed
                    vm.lot.purchLandedNetLbs = 0;
                    vm.lot.purchLandedGrossLbs = 0;
                    vm.lot.purchLandedTareLbs = 0;
                    //lot weight
                    vm.lot.lotWeightLbs = 0;
                    break;
                case 'MT':
                    //actual
                    vm.lot.purchNetMTs = 0;
                    vm.lot.purchGrossMTs = 0;
                    vm.lot.purchTareMTs = 0;
                    //landed
                    vm.lot.purchLandedNetMTs = 0;
                    vm.lot.purchLandedGrossMTs = 0;
                    vm.lot.purchLandedTareMTs = 0;
                    //lot weight
                    vm.lot.lotWeightMts = 0;
                    break;
            }
        }

        //==========================================
        //Lot Quality tab
        //==========================================
        //apply purchase contract quality to lot quality either actual or display
        vm.applyLotQuality = function( type ) {
            if( vm.lot.purchase !== null ) {
                switch( type ) {
                    case 'display':
                        vm.lot.lotMic = vm.lot.purchase.micDisplay;
                        vm.lot.lotLen = vm.lot.purchase.stapleDisplay;
                        vm.lot.lotStr = vm.lot.purchase.strengthDisplay;
                        break;
                    default:
                        vm.lot.lotMic = vm.lot.purchase.mic;
                        vm.lot.lotLen = vm.lot.purchase.staple;
                        vm.lot.lotStr = vm.lot.purchase.strength;
                        break;
                }
                ToastrService.info( "Applied P.Contract's " + type + " quality to Lot.", "Info" );
            } else {
                ToastrService.info( "No Purchase Contract Selected", "Info" );
            }
        };

    }
})();
